import * as _ from "lodash";
import DurationService from "app/services/DurationService";
import { WebsiteKeywordsDashboardTableWidgetFilters } from "../widget-filters/WebsiteKeywordsDashboardTableWidgetFilters";
import { TableTemplateV2 } from "../dashboard/TableTemplate-v2";
import { TableWidget } from "./TableWidget";
import { EKeywordTabs } from "app/UtilitiesAndConstants/Constants/SourceTypes";

export class WebsiteKeywordsDashboardTableWidget extends TableWidget {
    static getWidgetDashboardType() {
        return "Table";
    }

    static getWidgetMetadataType() {
        return "IndustryKeywordsDashboardTable";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    static getFiltersComponent() {
        return WebsiteKeywordsDashboardTableWidgetFilters;
    }

    constructor() {
        super();
    }

    public getSearchKey() {
        return "SearchTerm";
    }

    getProperties() {
        const props = super.getProperties();
        return props;
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }

    protected rowReducer(row) {
        const requestParams = this._params;
        const stateParams = {
            isWWW: "*", //for now - until fix for subdomains-domains
            duration: DurationService.getDiffSymbol(
                requestParams.from,
                requestParams.to,
                requestParams.isWindow ? "days" : "months",
            ),
            country: requestParams.country,
        };
        const rowParams = _.clone(stateParams);

        if (requestParams.metric.toLowerCase().indexOf("paid") > -1) {
            row.Paid = 1;
        }

        const isPaid = row.OrganicPaid || row.Paid == 1;
        _.extend(rowParams, {
            keyword: row.SearchTerm,
            selectedPageTab: isPaid ? EKeywordTabs[EKeywordTabs.Paid] : EKeywordTabs[EKeywordTabs.Organic],
        });
        row.url = this._swNavigator.href("organicsearch_keywordAnalysis_2", rowParams);
        return { ...row };
    }
}
WebsiteKeywordsDashboardTableWidget.register();
